<template lang="pug">
  .color-kit-ctas(:class="{'ask-a-colorist': chatAvailable && !nearColorBar}")
    sticky-wrap(stop-at="footer")
      .ctas-wrap(v-if="product.inventory_status == 'active'")
        template(v-if="product.renewable")
          button.purchase-btn.mr-btn.xs-f-xsmall.max-at-tweak(type="button" ref="addButton" @click="openPurchasePanelModal($refs.addButton)" data-mr-ass="floating-purchase-panel-button") Add To Bag 
            span.from-text.lower.light from {{product.sub_price | currency}}
        
        template(v-else="!product.renewable")
          button.purchase-btn.mr-btn.xs-f-xsmall.max-at-tweak(type="button" @click="addToBag()") Add To Bag 
            span.from-text.lower.light {{product.price | currency}}
        
        button.chat-btn.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak(v-if="chatAvailable && !nearColorBar" type="button" @click="$root.openChat") ask a colorist

      .ctas-wrap.text-center(v-else-if="product.inventory_status == 'coming_soon' || product.inventory_status == 'backordered'")
        WaitlistForm(:product-id="product.id" :inventory-status="product.inventory_status")

      .ctas-wrap.text-center(v-else-if="product.inventory_status == 'pre_order'")
        p.pre-order-text.xs-f-xmedium.md-f-large.lg-f-xmedium.max-at-tweak This product is currently available for pre&#8209;order. Shipments start {{product.preorder_promise_date | moment('MM/DD/YY')}}.
        button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(v-if="!preOrderId" type="button" ref="preOrderButton" @click="addToPreOrder") pre-order now {{product.price | currency}}
        button.mr-btn.btn-inverse.btn-fixed-width.xs-f-xsmall.max-at-tweak(v-else type="button" ref="preOrderButton" @click="cancelPreOrder") cancel pre-order

</template>

<script>
  import { mapActions } from 'vuex';
  import WaitlistForm from '../../WaitlistForm';
  import vueCartSvc from '../../../../services/vueCartSvc';

  export default {
    name: "ColorKitCTAs",

    components: {
      WaitlistForm
    },

    data() {
      return {
        checkPreOrder: 1
      }
    },

    props: {
      product: {
        type: Object,
        default: {}
      }
    },

    computed: {
      chatAvailable() {
        return this.$root.chatAvailable;
      },

      advisorAnswers() {
        return this.$root.advisorAnswers || {};
      },

      nearColorBar() {
        return this.advisorAnswers.near_colorbar;
      }
    },

    asyncComputed: {
      preOrderId() {
        if (this.product.id && this.checkPreOrder) {
          return vueCartSvc.getPreOrderId({
            productId: this.product.id
          }).then(res => res.data.id);
        }
      }
    },

    methods: {
      ...mapActions('pdp', ['openPurchasePanelModal']),
      ...mapActions('cart', ['addToCart']),

      addToBag() {
        this.addToCart({
          cartType: 'active',
          ctaSource: 'ColorKitCTAs',
          productId: this.product.id
        }).then(() => {
          window.location = '/cart';
        });
      },

      addToPreOrder() {
        this.addToCart({
          cartType: 'preorder',
          ctaSource: 'ColorKitCTAs',
          productId: this.product.id
        }).then(() => {
          window.location = '/checkout';
        });
      },

      cancelPreOrder() {
        vueCartSvc.cancelPreOrder({
          preOrderId: this.preOrderId
        }).then(() => {
          this.checkPreOrder += 1;
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .color-kit-ctas
    padding 1.5em 0
    
    .purchase-btn
      width 100%
    
    &.ask-a-colorist
      .purchase-btn
      .chat-btn
        width 49%
        
      .purchase-btn
        padding-top 0.4em
        padding-bottom 1.6em
        
        .from-text
          position absolute
          left 0
          right 0
          top 1.7em
          
      .chat-btn
        margin-left 2%
        padding-left 0.5em
        padding-right 0.5em
        
    .pre-order-text
      padding-bottom 0.5em
    
    @media mq-tablet-less
      .sticky-wrap
        min-height 3.75em
        
        .ctas-wrap
          opacity 100
          transition(opacity 300ms ease-in-out)
        
        &.fixed
          .ctas-wrap
            position fixed
            padding 0.75em 3%
            z-index 10
            left 0
            right 0
            bottom 0
            background-color color-white
            
        &.stopped
          .ctas-wrap
            opacity 0
            pointer-events none
    
</style>
